<template>
  <div class="post-edit">
    <a-form :form="form" @submit="handleSubmit">
      <div class="resume-title">
        <div class="line"></div>
        企业相关信息
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>公司名称</div>
          <a-form-item>
            <a-input-group compact>
              <a-auto-complete
                class="company"
                placeholder="仅可填写已签约的客户名称"
                size="large"
                v-decorator="[
                  'companyName',
                  {
                    rules: [
                      { required: true, message: '仅可填写已签约的客户名称' },
                    ],
                  },
                ]"
                @change="changeCompanyName"
                :dataSource="dataCompanyNameList"
                @select="selectComId"
              ></a-auto-complete>
            </a-input-group> </a-form-item>&nbsp;
          <a @click="goCompany">管理公司</a>
        </div>
        <div class="list-item">
          <div class="item-title">所属产品</div>
          <a-form-item>
            <!--@focus="getProduct"-->
            <a-select
              mode="multiple"
              placeholder="请填写所属产品"
              style="width: 400px"
              size="large"
              v-decorator="[
                'product_name',
                { rules: [{ required: false, message: '请填写所属产品！' }] },
              ]"
            >
              <a-select-option
                :value="item.name"
                v-for="(item, i) in productList"
                :key="i"
                >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>负责HR</div>
          <a-form-item>
            <!--@focus="getHR"-->
            <a-select
              placeholder="请填写负责HR"
              style="width: 400px"
              size="large"
              v-decorator="[
                'company_contacter_id',
                { rules: [{ required: true, message: '请填写负责HR！' }] },
              ]"
            >
              <a-select-option
                :value="item.id"
                v-for="item in hrList"
                :key="item.id"
                >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list-item"></div>
      </div>
      <div class="resume-title">
        <div class="line"></div>
        职位基本信息
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>职位名称</div>
          <a-form-item>
            <a-auto-complete
              style="width: 400px"
              size="large"
              placeholder="请填写职位名称"
              :dataSource="funcNameData"
              @search="changeFuncName"
              @select="selectFuncName"
              optionLabelProp="text"
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请填写职位名称！' }] },
              ]"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="item in funcNameData"
                  :key="
                    item.first_category_id +
                    ',' +
                    item.second_category_id +
                    ',' +
                    item.third_category_id
                  "
                  :text="
                    item.third_category_name ||
                    item.second_category_name ||
                    item.first_category_name
                  "
                  :originData="item"
                >
                  {{
                    item.third_category_name ||
                    item.second_category_name ||
                    item.first_category_name
                  }}
                  <div style="font-size: 12px">
                    {{
                      item.first_category_name +
                      ">" +
                      item.second_category_name +
                      ">" +
                      item.first_category_name
                    }}
                  </div>
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>职能类型</div>
          <a-form-item style="font-size: 14px">
            <a-cascader
              changeOnSelect
              :options="functionId"
              size="large"
              style="font-size: 14px"
              placeholder="请选择职能类型"
              @click="() => loadData('post')"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              v-decorator="[
                `category_id`,
                { rules: [{ required: true, message: '请选择职能类型' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>工作地点</div>
          <a-form-item>
            <el-cascader
              v-model="job_areas"
              ref="cityCascader"
              style="width: 400px"
              placeholder="请选择城市"
              :options="workCity"
              :props="{
                multiple: true,
                label: 'name',
                value: 'id',
                children: 'children',
                expandTrigger: 'hover',
              }"
              clearable
              @change="changeWorkCity"
            />
            <!-- <a-cascader
              changeOnSelect
              :options="workCity"
              size="large"
              placeholder="请选择城市"
              @click="() => loadData('nation')"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              v-decorator="[
                `location`,
                { rules: [{ required: true, message: '请填写工作地点！' }] }
              ]"
            /> -->
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>招聘人数</div>
          <a-form-item>
            <a-input
              placeholder="请填写招聘人数"
              size="large"
              style="width: 400px"
              v-decorator="[
                'quantity',
                { rules: [{ required: true, message: '请填写招聘人数！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>薪资范围</div>
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              v-decorator="[
                'hunter_salary_min',
                { rules: [{ required: true, message: '请填写薪资范围！' }] },
              ]"
            /> </a-form-item
          >&nbsp;—&nbsp;
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              v-decorator="[
                'hunter_salary_max',
                { rules: [{ required: true, message: '请填写薪资范围！' }] },
              ]"
            /> </a-form-item
          >&nbsp;万/年
        </div>
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>薪资制度</div>
          <a-form-item>
            <a-select
              placeholder="请填写薪资制度，例如13薪、15薪"
              style="width: 400px"
              size="large"
              v-decorator="[
                'salary_type',
                { rules: [{ required: true, message: '请填写薪资制度！' }] },
              ]"
            >
              <a-select-option value="1">12薪</a-select-option>
              <a-select-option value="2">13薪</a-select-option>
              <a-select-option value="3">14薪</a-select-option>
              <a-select-option value="4">15薪</a-select-option>
              <a-select-option value="5">16薪</a-select-option>
              <a-select-option value="6">16薪+</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>试用期薪资比例
          </div>
          <a-form-item>
            <a-input
              placeholder="请填写试用期薪资比例"
              class="marriage-select"
              size="large"
              v-decorator="[
                `probationary_salary_ratio`,
                {
                  rules: [
                    { required: true, message: '请填写试用期薪资比例！' },
                    {
                      transform(value) {
                        return +value;
                      },
                      type: 'number',
                      message: '请输入数字！',
                    },
                  ],
                },
              ]"
              addonAfter="%"
            />
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title">职位级别</div>
          <a-form-item>
            <a-input
              placeholder="请填写职位级别"
              size="large"
              style="width: 400px"
              v-decorator="[
                'level',
                { rules: [{ required: false, message: '请填写职位级别！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">平级情况</div>
          <a-form-item>
            <a-input
              placeholder="请填写平级情况"
              class="marriage-select"
              size="large"
              v-decorator="[
                `samelevel`,
                { rules: [{ required: false, message: '' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="text-arie">
        <div class="text-arie-title">下属团队</div>
        <a-form-item>
          <a-textarea
            placeholder="下属团队的平均年龄、学历及来源"
            :rows="5"
            maxlength="100"
            v-decorator="[
              `subordinate_team`,
              {
                rules: [
                  {
                    max: 100,
                    required: false,
                    message: '团队介绍不能超过100字',
                  },
                ],
              },
            ]"
            @change="handleteamLength"
          />
          <span class="count">{{ teamLength }} / 100</span>
        </a-form-item>
      </div>
      <div class="resume-title">
        <div class="line"></div>
        薪资福利
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>税前薪资</div>
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              addonAfter="K"
              v-decorator="[
                'salary_benefits.pre_tax_salary.min',
                { rules: [{ required: true, message: '请填写薪资范围！' }] },
              ]"
            /> </a-form-item
          >&nbsp;—&nbsp;
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              addonAfter="K"
              v-decorator="[
                'salary_benefits.pre_tax_salary.max',
                { rules: [{ required: true, message: '请填写薪资范围！' }] },
              ]"
            /> </a-form-item
          >&nbsp;*&nbsp;
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              addonAfter="月"
              v-decorator="[
                'salary_benefits.pre_tax_salary.month_count',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写薪资制度，例如13薪、15薪',
                    },
                  ],
                },
              ]"
            /> </a-form-item
          >&nbsp;(12-100月)
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">薪资构成</div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['salary_benefits.salary_structure.sels']"
              style="width: 100%"
            >
              <a-checkbox value="基本薪资">基本薪资</a-checkbox>
              <a-checkbox value="奖金/提成">奖金/提成</a-checkbox>
              <a-checkbox value="期权">期权</a-checkbox>
              <a-checkbox
                value="其他"
                :checked="salaryStructureOther"
                @change="onChangeOther1"
                >其他</a-checkbox
              >
            </a-checkbox-group>
          </a-form-item>
          <a-form-item>
            <a-input
              v-if="salaryStructureOther"
              size="large"
              style="width: 400px"
              v-decorator="['salary_benefits.salary_structure.other']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">社保福利</div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['salary_benefits.social_benefits.sels']"
              style="width: 100%"
            >
              <a-checkbox value="国家标准">国家标准</a-checkbox>
              <a-checkbox value="商业保险">商业保险</a-checkbox>
              <a-checkbox
                value="其他"
                :checked="socialBenefitsOther"
                @change="onChangeOther2"
                >其他</a-checkbox
              >
            </a-checkbox-group>
          </a-form-item>
          <a-form-item>
            <a-input
              v-if="socialBenefitsOther"
              size="large"
              style="width: 400px"
              v-decorator="['salary_benefits.social_benefits.other']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">居住福利</div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['salary_benefits.live_benefits.sels']"
              style="width: 100%"
            >
              <a-checkbox value="住房补贴">住房补贴</a-checkbox>
              <a-checkbox value="公司安排">公司安排</a-checkbox>
              <a-checkbox
                value="其他"
                :checked="liveBenefitsOther"
                @change="onChangeOther3"
                >其他</a-checkbox
              >
            </a-checkbox-group>
          </a-form-item>
          <a-form-item>
            <a-input
              v-if="liveBenefitsOther"
              size="large"
              style="width: 400px"
              v-decorator="['salary_benefits.live_benefits.other']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">年假福利</div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['salary_benefits.vacation_benefits.sels']"
              style="width: 100%"
            >
              <a-checkbox value="国家标准">国家标准</a-checkbox>
              <a-checkbox
                value="其他"
                :checked="vacationBenefitsOther"
                @change="onChangeOther4"
                >其他</a-checkbox
              >
            </a-checkbox-group>
          </a-form-item>
          <a-form-item>
            <a-input
              v-if="vacationBenefitsOther"
              size="large"
              style="width: 400px"
              v-decorator="['salary_benefits.vacation_benefits.other']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">通讯交通</div>
          <a-form-item>
            <a-radio-group
              v-decorator="['salary_benefits.traffic_benefits.sels']"
              style="width: 100%"
            >
              <a-radio value="不确定">不确定</a-radio>
              <a-radio value="无补助">无补助</a-radio>
              <a-radio value="有补助">有补助</a-radio>
              <a-radio value="实时报销">实时报销</a-radio>
              <a-radio value="其他">其他</a-radio>
            </a-radio-group>
          </a-form-item>
        </div>
      </div>
      <!-- <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>试用期薪资比例
          </div>
          <a-form-item>
            <a-input
              placeholder="请填写试用期薪资比例"
              class="marriage-select"
              size="large"
              v-decorator="[
                `probationary_salary_ratio`,
                {
                  rules: [
                    { required: true, message: '请填写试用期薪资比例！' },
                    {
                      transform(value) {
                        return +value;
                      },
                      type: 'number',
                      message: '请输入数字！'
                    }
                  ]
                }
              ]"
              addonAfter="%"
            />
          </a-form-item>
        </div>
      </div> -->
      <div class="resume-title">
        <div class="line"></div>
        职位要求
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">年龄要求</div>
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              addonAfter="岁"
              v-decorator="['age_requirement_min']"
            /> </a-form-item
          >&nbsp;—&nbsp;
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 100px"
              addonAfter="岁"
              v-decorator="['age_requirement_max']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">专业要求</div>
          <a-form-item>
            <a-input
              placeholder
              size="large"
              style="width: 400px"
              v-decorator="['major_requirement']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">语言要求</div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['language_requirement']"
              style="width: 100%"
            >
              <a-checkbox value="英语">英语</a-checkbox>
              <a-checkbox value="普通话">普通话</a-checkbox>
              <a-checkbox value="粤语">粤语</a-checkbox>
              <a-checkbox value="日语">日语</a-checkbox>
              <a-checkbox value="法语">法语</a-checkbox>
              <a-checkbox value="其他">其他</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">行业要求</div>
          <a-form-item>
            <el-cascader
              v-model="job_industrys"
              ref="industryCascader"
              style="width: 400px"
              placeholder="请选择行业"
              :options="jobIndustry"
              :props="{
                multiple: true,
                label: 'name',
                value: 'id',
                children: 'children',
                expandTrigger: 'hover',
              }"
              clearable
              @change="changeIndustry"
            />
            <!-- <a-cascader
              :options="industry"
              size="large"
              :fieldNames="{
                label: 'name',
                value: 'id',
                children: 'children'
              }"
              changeOnSelect
              placeholder="请选择所属行业"
              @click="() => loadData('industry')"
              v-decorator="[ 'Industry' ]"
            ></a-cascader> -->
          </a-form-item>
        </div>

      </div>
      <div class="text-arie">
        <div class="text-arie-title">
          <span class="red-color">*</span>工作内容
        </div>
<!--        <div>-->
        <a-form-item>
          <a-textarea 
          style = "padding-bottom: 50px"
            placeholder="请尽可能详细，准确的描述工作内容，有助于您快速找到匹配的候选人：
例如：
1、工作内容
2、特别说明
"
            :rows="10"
            maxlength="1000"
            v-decorator="[
              `requirements`,
              {
                rules: [
                  { max: 1000, required: true, message: '请填写工作内容！' },
                ],
              },
            ]"
            @change="handleWorkLength"
          />
          <div style="position: absolute; left: 25px; bottom: -6px; right: 25px; height: 50px; background-color: white;"> </div>
          <span class="count" style="position: absolute; left: 40px; bottom: 0px;">{{ workLength }} / 1000</span>
          <div class = "ai-button" @click="showAIDialog('work')">AI一键生成工作内容</div>
<!--          aiContentType-->
        </a-form-item>

      </div>
<!--      </div>-->l
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>技能要求</div>
          <a-form-item>
            <a-input
              class="other-input"
              placeholder="请选择附加要求"
              size="large"
              style="width: 400px; cursor: pointer"
              v-decorator="[
                'requirement_skill',
                { rules: [{ required: false, message: '请选择技能标签' }] },
              ]"
              readonly
              @click="showTagsModal('requirement_skill')"
            />
          </a-form-item>

        </div>
      </div>
      <div class="text-arie">
        <div class="text-arie-title">
          <span class="red-color">*</span>任职要求
        </div>
        <a-form-item>
          <a-textarea
            placeholder="（JD以外有什么要求）对人选过去所在公司的特别要求，其他经验经历要求，语言，证书，学历，年龄，性别，性格，出差，应酬，工作时间以及其他特殊偏好"
            :rows="10"
            v-decorator="[
              `description`,
              { rules: [{ required: true, message: '请填写任职要求！' }] },
            ]"
          />

          <div style="position: absolute; left: 25px; bottom: -6px; right: 25px; height: 50px; background-color: white;"> </div>
          <!-- <span class="count" style="position: absolute; left: 40px; bottom: 0px;">{{ workLength }} / 1000</span> -->
          <div class = "ai-button" @click="showAIDialog('requirement')">AI一键生成任职要求</div>
         
        </a-form-item>
      </div>

      <div class="resume-title">
        <div class="line"></div>
        职位候选人要求
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>性别要求</div>
          <a-form-item>
            <a-radio-group
              :options="[
                { label: '不限', value: '0' },
                { label: '男', value: '1' },
                { label: '女', value: '2' },
              ]"
              v-decorator="[
                `gender_id`,
                { rules: [{ required: true, message: '请选择性别！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>学校类型</div>
          <a-form-item>
            <a-radio-group
              :options="[
                { label: '不限', value: '0' },
                { label: '211/985', value: '1' },
                { label: '海归', value: '2' },
              ]"
              v-decorator="[
                `school_type`,
                { rules: [{ required: true, message: '请选择学校类型！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>工作经验</div>
          <a-form-item>
            <a-radio-group
              :options="workExperienceData"
              style="width: 900px"
              v-decorator="[
                `experience_id`,
                { rules: [{ required: true, message: '请选择工作经验！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>学历要求</div>
          <a-form-item>
            <a-radio-group
              :options="educationData"
              style="width: 900px"
              v-decorator="[
                `education_id`,
                { rules: [{ required: true, message: '请选择学历！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>是否统招</div>
          <a-form-item>
            <a-radio-group
              :options="fullTimeData"
              style="width: 900px"
              v-decorator="[
                `full_time_type`,
                { rules: [{ required: true, message: '请选择是否统招！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>所学专业</div>
          <a-form-item>
            <el-cascader
              placeholder="可输入搜索"
              :options="majorDataoptions"
              :props="{
                label: 'name',
                value: 'id',
              }"
              :disabled="majordisabled"
              @change="handleChange"
              v-model="majorDataoptions_value"
              filterable
            >
            </el-cascader>
            <a-checkbox
              style="margin-left: 10px"
              v-model="majorchecked"
              @change="majorChange"
              >不限专业</a-checkbox
            >
          </a-form-item>
        </div>
      </div>
      <div class="resume-title">
        <div class="line"></div>
        获选人画像
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">不考虑出生地</div>
          <a-form-item>
            <a-cascader
              changeOnSelect
              :options="area"
              size="large"
              placeholder="请选择"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              @click="() => loadData('nation')"
              @change="changeInactiveBorn"
              v-decorator="['inactive_born']"
            />
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title">优先考虑出生地</div>
          <a-form-item>
            <a-cascader
              changeOnSelect
              :options="area"
              size="large"
              placeholder="请选择"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              @click="() => loadData('nation')"
              @change="changeActiveBorn"
              v-decorator="['active_born']"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">不考虑性别</div>
          <a-form-item>
            <a-radio-group
              :options="[
                { label: '男', value: 1 },
                { label: '女', value: 2 },
              ]"
              v-decorator="[`draw_portrait_inactive_tag.inactive_gender_id`]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">不考虑频繁跳槽</div>
          <a-form-item>
            <a-radio-group
              :options="[
                { label: '5年2跳', value: 1 },
                { label: '5年3跳', value: 2 },
              ]"
              v-decorator="[
                `draw_portrait_inactive_tag.inactive_job_hopping_interval`,
              ]"
            />
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title">优先考虑跳槽</div>
          <a-form-item>
            <a-radio-group
              :options="[
                { label: '3年1跳', value: 3 },
                { label: '5年1跳', value: 4 },
              ]"
              v-decorator="[
                `draw_portrait_active_tag.active_job_hopping_interval`,
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">不考虑生肖</div>
          <a-form-item>
            <a-select
              placeholder="请选择生肖"
              style="width: 200px"
              size="large"
              v-decorator="['draw_portrait_inactive_tag.inactive_zodiac_sign']"
            >
              <template v-for="(item, index) in zodiac">
                <a-select-option :key="index + 1" :value="index + 1">{{
                  item
                }}</a-select-option>
              </template>
            </a-select>
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title">优先考虑生肖</div>
          <a-form-item>
            <a-select
              placeholder="请选择生肖"
              style="width: 200px"
              size="large"
              v-decorator="['draw_portrait_active_tag.active_zodiac_sign']"
            >
              <template v-for="(item, index) in zodiac">
                <a-select-option :key="index + 1" :value="index + 1">{{
                  item
                }}</a-select-option>
              </template>
            </a-select>
          </a-form-item>
        </div>
      </div>
      <!-- 更多画像条件 -->
      <div v-show="showMorePortrait">
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑婚姻情况</div>
            <a-form-item>
              <a-radio-group
                :options="[
                  { label: '已婚已孕', value: 3 },
                  { label: '已婚', value: 2 },
                  { label: '未婚', value: 1 },
                ]"
                v-decorator="[`draw_portrait_inactive_tag.inactive_is_married`]"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑</div>
            <a-form-item>
              <a-radio-group
                :options="[
                  { label: '未婚', value: 1 },
                  { label: '已婚', value: 2 },
                ]"
                v-decorator="[`draw_portrait_active_tag.active_is_married`]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑薪资</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="K"
                v-decorator="['draw_portrait_inactive_tag.inactive_salary_min']"
              /> </a-form-item
            >&nbsp;—&nbsp;
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="K"
                v-decorator="['draw_portrait_inactive_tag.inactive_salary_max']"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑薪资</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="K"
                v-decorator="['draw_portrait_active_tag.active_salary_min']"
              /> </a-form-item
            >&nbsp;—&nbsp;
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="K"
                v-decorator="['draw_portrait_active_tag.active_salary_max']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑年龄</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="岁"
                v-decorator="['draw_portrait_inactive_tag.inactive_age_min']"
              /> </a-form-item
            >&nbsp;—&nbsp;
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="岁"
                v-decorator="['draw_portrait_inactive_tag.inactive_age_max']"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑年龄</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="岁"
                v-decorator="['draw_portrait_active_tag.active_age_min']"
              /> </a-form-item
            >&nbsp;—&nbsp;
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 100px"
                addonAfter="岁"
                v-decorator="['draw_portrait_active_tag.active_age_max']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑统招类型</div>
            <a-form-item>
              <a-radio-group
                :options="[
                  { label: '统招', value: 1 },
                  { label: '非统招', value: 2 },
                ]"
                v-decorator="[
                  `draw_portrait_inactive_tag.inactive_admission_type`,
                ]"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先第一学历考虑</div>
            <a-form-item>
              <a-radio-group
                :options="[
                  { label: '普通高校', value: 0 },
                  { label: '211院校', value: 1 },
                  { label: '985院校', value: 2 },
                  { label: '985/211', value: 3 },
                  { label: '外国院校', value: 4 },
                ]"
                v-decorator="[`draw_portrait_active_tag.active_school_type`]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑工作年限</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 120px"
                addonAfter="年以下"
                v-decorator="[
                  'draw_portrait_inactive_tag.inactive_working_years',
                ]"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑工作年限</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 120px"
                addonAfter="年以上"
                v-decorator="['draw_portrait_active_tag.active_working_years']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑管理低于</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 120px"
                addonAfter="人以下"
                v-decorator="[
                  'draw_portrait_inactive_tag.inactive_manage_people',
                ]"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑管理</div>
            <a-form-item>
              <a-input
                placeholder
                size="large"
                style="width: 120px"
                addonAfter="人以上"
                v-decorator="['draw_portrait_active_tag.active_manage_people']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑非专业</div>
            <a-form-item>
              <a-input
                placeholder="不限"
                style="width: 300px"
                size="large"
                v-decorator="['draw_portrait_inactive_tag.inactive_major']"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑专业</div>
            <a-form-item>
              <a-input
                placeholder="不限"
                style="width: 300px"
                size="large"
                v-decorator="['draw_portrait_active_tag.active_major']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">不考虑非证书</div>
            <a-form-item>
              <a-input
                placeholder="不限"
                style="width: 300px"
                size="large"
                v-decorator="[
                  'draw_portrait_inactive_tag.inactive_certificate',
                ]"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">优先考虑证书</div>
            <a-form-item>
              <a-input
                placeholder="不限"
                style="width: 300px"
                size="large"
                v-decorator="['draw_portrait_active_tag.active_certificate']"
              />
            </a-form-item>
          </div>
        </div>
      </div>

      <div class="more-portrait">
        <a
          href="javascript:;"
          v-if="!showMorePortrait"
          @click="showMorePortrait = true"
          >查看更多
          <a-icon type="down" />
        </a>
        <a href="javascript:;" v-else @click="showMorePortrait = false"
          >收起更多
          <a-icon type="up" />
        </a>
      </div>

      <div class="resume-title">
        <div class="line"></div>
        职位备注
      </div>
      <div class="interview-body">
        <div class="interview">
          <div
            class="item-title"
            style="font-weight: bold; color: black; line-height: 38px"
          >
            面试流程
          </div>
          <div class="interview-list">
            <a-form-item
              v-for="(k, index) in interview.keys"
              :key="k"
              :required="false"
            >
              第{{ index + 1 }}轮&nbsp;&nbsp;
              <a
                @click="deleteInterview(index)"
                v-if="interview.keys.length > 1"
                >删除</a
              >
              <a @click="addInterview" v-if="index == interview.keys.length - 1"
                >&nbsp;&nbsp;新增</a
              >
              <a-form-item>
                <a-input
                  placeholder="请填写该轮面试形式，如HR面、业务面......"
                  size="large"
                  v-decorator="[
                    `interviews[${k}]`,
                    {
                      rules: [{ required: false, message: '请填写薪资范围！' }],
                    },
                  ]"
                />
              </a-form-item>
            </a-form-item>
          </div>
        </div>
      </div>
      <div class="tags-list">
        <div class="item-title">职位卖点</div>
        <div class="tags-info">
          <template v-for="tag in sellPointTags">
            <a-checkable-tag
              style="border: #35b5fe 1px solid"
              :key="tag"
              :checked="selectedSellPointTags.indexOf(tag) > -1"
              @change="(checked) => handleChangeTags(tag, checked)"
              >{{ tag }}
            </a-checkable-tag>
          </template>
        </div>
        <a @click="addSellingPoint">新增标签</a>
      </div>
      <div style="clear: both"></div>
      <div class="tags-list">
        <div class="item-title">招聘原因</div>
        <div class="tags-info">
          <template v-for="tag in reasonTags">
            <a-checkable-tag
              style="border: #35b5fe 1px solid"
              :key="tag"
              :checked="selectedReasonTags.indexOf(tag) > -1"
              @change="(checked) => handleReasonChangeTags(tag, checked)"
              >{{ tag }}
            </a-checkable-tag>
          </template>
        </div>
        <a @click="addReasons">新增标签</a>
      </div>
      <div style="clear: both"></div>
      <div class="interview-body">
        <div class="interview">
          <div
            class="item-title"
            style="font-weight: bold; color: black; line-height: 38px"
          >
            <span class="red-color">*</span>搜寻方向
          </div>
          <div style="width: 950px">
            <div style="line-height: 38px">添加第一目标公司</div>
            <a-input-group compact>
              <a-auto-complete
                class="company"
                placeholder="请填写公司名称"
                size="large"
                v-model="firstCompanyName"
                :dataSource="dataFirstCompanyName"
                @change="changeFirstCompanyName"
                style="width: 600px; float: left"
                @select="addCompanyData"
              />
              <!-- <a-button
                type="primary"
                style="float: left"
                size="large"
                @click="onAddFirstCompany"
                >添加</a-button
              >-->
            </a-input-group>
            <div class="company-list" v-if="firstObjective.length > 0">
              <div v-for="(item, i) in firstObjective" :key="i">
                <div class="company-name">
                  {{ item.company_name }}
                  <div class="delete-com" @click="deleteFirstCompany(i)">
                    <a-icon type="close" />
                  </div>
                </div>
                <div style="clear: both"></div>
                <div class="addProduct">
                  添加产品：
                  <template v-for="tag in item.productList">
                    <a-checkable-tag
                      style="border: #35b5fe 1px solid; margin-bottom: 10px"
                      :key="tag"
                      :checked="item.selectedProductList.indexOf(tag) > -1"
                      @change="
                        (checked) => handleChangeProduct(tag, checked, i)
                      "
                      >{{ tag }}
                    </a-checkable-tag>
                    <!--<Tags :tag="tag" :selectedProductList="item.selectedProductList"></Tags>-->
                  </template>
                </div>
                <div class="addProduct">
                  添加备注：
                  <a-input
                    placeholder="请填写备注"
                    size="large"
                    v-model="item.notes"
                    style="width: 850px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="interview-body">
        <div class="interview">
          <div
            class="item-title"
            style="font-weight: bold; color: black; line-height: 38px"
          ></div>
          <div style="width: 950px">
            <div style="line-height: 38px">添加第二目标公司</div>
            <a-input-group compact>
              <a-auto-complete
                class="company"
                placeholder="请填写公司名称"
                size="large"
                v-model="secondCompanyName"
                :dataSource="dataSecondCompanyName"
                @change="changeSecondCompanyName"
                style="width: 600px; float: left"
                @select="addSecondCompanyData"
              />
              <!-- <a-button
                type="primary"
                style="float: left"
                size="large"
                @click="onAddSecondCompany"
                >添加</a-button
              >-->
            </a-input-group>
            <div class="company-list" v-if="secondObjective.length > 0">
              <div v-for="(item, i) in secondObjective" :key="i">
                <div class="company-name">
                  {{ item.company_name }}
                  <div class="delete-com" @click="deleteSecondCompany(i)">
                    <a-icon type="close" />
                  </div>
                </div>
                <div style="clear: both"></div>
                <div class="addProduct">
                  添加产品：
                  <template v-for="tag in item.productList">
                    <a-checkable-tag
                      style="border: #35b5fe 1px solid"
                      :key="tag"
                      :checked="item.selectedProductList.indexOf(tag) > -1"
                      @change="
                        (checked) => handleChangeSecondProduct(tag, checked, i)
                      "
                      >{{ tag }}
                    </a-checkable-tag>
                  </template>
                </div>
                <div class="addProduct">
                  添加备注：
                  <a-input
                    placeholder="请填写备注"
                    v-model="item.notes"
                    size="large"
                    style="width: 850px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="interview-body">
        <div class="interview">
          <div
            class="item-title"
            style="font-weight: bold; color: black; line-height: 38px"
          ></div>
          <div style="width: 950px">
            <div style="line-height: 38px">添加其他要求</div>
            <a-form-item>
              <a-input
                placeholder="请添加其他要求"
                size="large"
                v-decorator="[
                  'directions',
                  { rules: [{ required: false, message: '请填写其他要求！' }] },
                ]"
              />
            </a-form-item>
          </div>
        </div>
      </div>
      <div class="text-arie">
        <div class="text-arie-title">职位进展</div>
        <a-form-item>
          <a-textarea
            placeholder="紧急度？从什么时候开始招聘？如果已经开始了一段时间，那么到目前还未招聘到的原因？目前进展如何，是否还有在流程中的人选，都在什么流程上？看过多少人？都是什么背景？不合适的原因？HR认为的难点所在？我们介入建议重点从哪入手？是否可以提供之前被推荐过人选的名录？有没有目前不用去搜寻的公司？"
            :rows="10"
            maxlength="500"
            v-decorator="[
              `recruitment_progress`,
              {
                rules: [{ max: 500, required: false, message: '不超过500字' }],
              },
            ]"
            @change="handleProgressLength"
          />
          <span class="count">{{ progressLength }} / 500</span>
        </a-form-item>
      </div>
      <div class="input-list2">
        <div class="text-arie-title">上传附件</div>
        <a-upload
          name="file"
          :multiple="false"
          style="margin-left: 20px"
          :action="baseURL + '/common/file/upload'"
          @change="uploadChange"
          :data="{ token: token }"
          :fileList="fileList"
        >
          <a-button>
            <a-icon type="upload" />
            上传附件
          </a-button>
        </a-upload>
        <span style="font-size: 12px; margin-top: 8px"
          >&nbsp;&nbsp;文件格式：txt，pdf，doc，xls，docx，xlsx，html</span
        >
      </div>
      <div class="resume-title">
        <div class="line"></div>
        职位评级
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>甲方委托猎企数
          </div>
          <a-form-item>
            <a-radio-group
              :options="entrustedHunting"
              style="width: 900px"
              v-decorator="[
                'num_published_platforms',
                {
                  rules: [
                    { required: true, message: '请填写甲方委托猎企数！' },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>面向社会已开放时长
          </div>
          <a-form-item>
            <a-radio-group
              :options="peningTime"
              style="width: 900px"
              v-decorator="[
                `open_duration`,
                {
                  rules: [
                    { required: true, message: '请填写面向社会已开放时长！' },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>职位紧急程度
          </div>
          <a-form-item>
            <a-radio-group
              :options="mergencyPosition"
              style="width: 900px"
              v-decorator="[
                `urgency_level`,
                {
                  rules: [{ required: true, message: '请填写职位紧急程度！' }],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>职位难度</div>
          <a-form-item>
            <a-radio-group
              :options="positionDifficulty"
              style="width: 900px"
              v-decorator="[
                `grade`,
                { rules: [{ required: true, message: '请填写职位难度！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>职位类型</div>
          <a-form-item>
            <a-radio-group
              :options="positionType"
              style="width: 900px"
              v-decorator="[
                `type`,
                { rules: [{ required: true, message: '请填写职位类型！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>

      <div class="resume-title">
        <div class="line"></div>
        职位负责人及服务方式
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title">
            <span class="red-color">*</span>职位负责人
          </div>
          <a-form-item>
            <a-input-group compact>
              <a-auto-complete
                style="width: 400px"
                placeholder="请填写职位负责人"
                size="large"
                v-decorator="[
                  'ie_user_id',
                  {
                    rules: [{ required: true, message: '请选择职位负责人！' }],
                  },
                ]"
                :dataSource="dataCharge"
                @change="handleChangeCharge"
                @select="selectPostLeader"
              />
            </a-input-group>
            <!--@change="changeCompanyName"-->
            <!--:dataSource="dataCompanyNameList"-->
            <!--@select="selectComId"-->
            <!--<a-form-item >-->
            <!--<a-input placeholder="请填写职位负责人" size="large"  v-decorator="[ 'post_Leader',{rules: [{ required: true, message: '请填写职位负责人！' }]}]"/>-->
            <!--</a-form-item>-->
          </a-form-item>
        </div>
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>联系电话</div>
          <a-form-item>
            <a-input
              placeholder="请填写联系电话"
              size="large"
              style="width: 400px"
              disabled
              v-decorator="[
                'post_tel',
                { rules: [{ required: true, message: '请填写联系电话！' }] },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="input-list">
        <div class="list-item">
          <div class="item-title"><span class="red-color">*</span>服务方式</div>
          <a-radio-group
            buttonStyle="solid"
            @change="onChangeServiceMode"
            v-model="is_reward_type"
          >
            <a-radio-button value="0">猎头服务</a-radio-button>
            <a-radio-button value="1">寻找人才线索</a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div v-show="is_reward_type == '0'">
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">
              <span class="red-color">*</span>签约佣金
            </div>
            <a-input-group
              compact
              style="align-items: center; display: flex; width: 400px"
            >
              <a-form-item>
                <a-select
                  style="width: 86px"
                  @change="handleChangeCommission"
                  size="large"
                  v-decorator="['hunter_commission_type']"
                >
                  <a-select-option value="1">按比例</a-select-option>
                  <a-select-option value="2">按佣金</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-input
                  :placeholder="showCommission ? '请填写佣金' : '请填写比例'"
                  size="large"
                  v-decorator="[
                    'hunter_commission_value',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写佣金！',
                          validator: verificationFunTwo,
                        },
                      ],
                    },
                  ]"
                  :addonAfter="showCommission ? '' : '%'"
                  style="margin-top: 1px; width: 315px"
                />
              </a-form-item>
            </a-input-group>
          </div>
          <div class="list-item">
            <div class="item-title"><span class="red-color">*</span>保证期</div>
            <a-form-item>
              <a-select
                placeholder="请选择保证期"
                style="width: 400px"
                size="large"
                v-decorator="[
                  'probation',
                  {
                    rules: [
                      {
                        message: '请选择保证期！',
                        validator: verificationFunTwo,
                      },
                    ],
                  },
                ]"
              >
                <template v-for="(item, index) in config.probation">
                  <a-select-option :key="index" :value="index">{{
                    item
                  }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="text-arie">
          <div class="text-arie-title">付款细则</div>
          <a-form-item>
            <a-textarea
              placeholder="退款条约等"
              :rows="10"
              v-decorator="[
                `payment_info`,
                { rules: [{ max: 200, required: false, message: '' }] },
              ]"
              @change="handleRefundLength"
            />
            <span class="count">{{ refundLength }} / 200</span>
          </a-form-item>
        </div>
      </div>
      <div v-show="is_reward_type == '1'">
        <div class="input-list">
          <div class="list-item">
            <div class="item-title">
              <span class="red-color">*</span>悬赏金额
            </div>
            <a-form-item>
              <a-input
                placeholder="请填写悬赏金额"
                size="large"
                v-decorator="[
                  'reward_amount',
                  {
                    rules: [
                      {
                        message: '请填写悬赏金额！',
                        validator: verificationFun,
                      },
                    ],
                  },
                ]"
                addonAfter="元"
                style="width: 400px"
              />
            </a-form-item>
          </div>
          <div class="list-item">
            <div class="item-title">
              <span class="red-color">*</span>悬赏政策
            </div>
            <a-form-item>
              <a-select
                placeholder="请选择悬赏政策"
                style="width: 400px"
                size="large"
                v-decorator="[
                  'reward_policy',
                  {
                    rules: [
                      {
                        message: '请选择悬赏政策！',
                        validator: verificationFun,
                      },
                    ],
                  },
                ]"
              >
                <a-select-option value="1">到面</a-select-option>
                <a-select-option value="2">过一面</a-select-option>
                <a-select-option value="3">发offer</a-select-option>
                <a-select-option value="4">入职</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
      </div>
            <div class="resume-title">
        <div class="line"></div>
        平台激励政策
      </div>
              <div class="text-arie">
          <div class="text-arie-title">政策内容</div>
          <a-form-item>
            <a-textarea
              placeholder="请填写平台激励政策"
              :rows="10"
              v-decorator="[
                `platform_policy`,
                { rules: [{ max: 200, required: false, message: '' }] },
              ]"
              @change="handlePolicy"
            />
            <span class="count">{{ policyLength }} / 200</span>
          </a-form-item>
        </div>

      <div class="btn-affix">
        <div class="bottom-button">
          <a-button size="large" type="primary" html-type="submit"
            >下一步</a-button
          >
          <a-button size="large" @click="() => onPreview()">预览</a-button>
        </div>
      </div>

    </a-form>
    <!--新增标签-->
    <a-modal v-model="addTags" title="新增标签">
      <template slot="footer">
        <a-button key="back" @click="cancelTags">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="addTagLoading"
          @click="addTagsModal"
          >新增</a-button
        >
      </template>
      <a-input placeholder="输入标签" :rows="4" v-model="tagsValue" />
    </a-modal>
    <!--新增招聘原因标签-->
    <a-modal v-model="addReasonTags" title="新增标签">
      <template slot="footer">
        <a-button key="back" @click="cancelReasonTags">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="addTagLoading"
          @click="addReasonTagsModal"
          >新增
        </a-button>
      </template>
      <a-input placeholder="输入标签" :rows="4" v-model="tagsReasonValue" />
    </a-modal>
    <!-- AI弹窗  -->
<!--    <div style = "width:100%; height: 100%;">-->
<!--    :parentLimitation="true"-->
      <VueDragResize
          v-if = "showAIAlert"
          :isActive="true"
          :isResizable="false"
          :preventActiveBehavior="true"
          :delay="1"
          class="custom-draggable-resizable"
          style = "
          position: fixed;
          z-index: 99999;
          background: #FFFFFF;
          box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
          border-radius: 6px;"
          :w="500"
          :h="480"
          :x="windowWidth - 520"
          :y="200"
      >
        <AIAssistant @close="closeAct()" @filling = "filling" :contentType = "aiContentType" :jsonData = "aiJsonData"/>
      </VueDragResize>
<!--    </div>-->



    <TagsModal
      ref="tagsModal"
      :tagList="skillsTag"
      @ok="updateSkills"
    ></TagsModal>
    <div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import moment from "moment";
import { mapState } from "vuex";
import TagsModal from "./tags-modal";
import VueDragResize from 'vue-drag-resize';
import AIAssistant from '@/components/ai-assistant/ai-assistant.vue'

let a = 0;
let baseURL = process.env.VUE_APP_BASEURL;
var timer;
export default {
  name: "edit-post",
  components: {
    TagsModal,
    AIAssistant,
    VueDragResize,
    // DragView
  },
  data() {
    return {
      aiAlertX: null,
      aiAlertY: null,
      showAIAlert: false, // 是否展示AI对话框
      aiContentType: "", // 1、工作内容，2、任职要求
      aiJsonData : null,
      windowWidth: 0,

      bottom: 60,
      formLayout: "horizontal",
      post_id: null,
      post: {},
      form: this.$form.createForm(this),
      area: [{ name: "全国", id: 0 }],
      workCity: [],
      job_areas: [],
      jobIndustry: [],
      job_industrys: [],
      functionId: [{ name: "职能", id: 0 }],
      industry: [{ name: "行业", id: 0 }],
      funcNameData: [], // 职位名称数据
      name: "", //职位名称
      list: {
        nation: {
          fun: "getCityTree",
          key: "tree",
          init: { name: "全国", id: 0 },
        },
        post: {
          fun: "getPostTree",
          key: "tree",
          init: { name: "职能", id: 0 },
        },
        industry: {
          fun: "getIndustryTree",
          key: "tree",
          init: { name: "行业", id: 0 },
        },
      },
      teamLength: 0,
      workLength: 0,
      progressLength: 0,
      refundLength: 0,
      policyLength:0,
      workExperienceData: [
        { label: "不限", value: "0" },
        { label: "1年以下", value: "1" },
        { label: "1-3年", value: "2" },
        { label: "3-5年", value: "3" },
        { label: "5-10年", value: "4" },
        { label: "10-15年", value: "5" },
        { label: "15年以上", value: "6" },
      ],
      educationData: [
        { label: "不限", value: "0" },
        { label: "博士", value: "1" },
        { label: "MBA/EMBA", value: "2" },
        { label: "硕士", value: "3" },
        { label: "本科", value: "4" },
        { label: "大专", value: "5" },
        { label: "高中/中专", value: "6" },
      ],
      fullTimeData: [
        { label: "必须是", value: "1" },
        { label: "无所谓", value: "2" },
      ],
      entrustedHunting: [
        { label: "独家/有预付费", value: "1" },
        { label: "小于3家", value: "2" },
        { label: "3-5家", value: "3" },
        { label: "超过5家", value: "4" },
      ],
      peningTime: [
        { label: "小于一周", value: "1" },
        { label: "1-3周", value: "2" },
        { label: "3周以上", value: "3" },
        { label: "常年招聘", value: "4" },
      ],
      mergencyPosition: [
        { label: "非常紧急", value: "1" },
        { label: "一般紧急", value: "2" },
        { label: "不紧急", value: "3" },
        { label: "假职位/储备简历目的", value: "4" },
      ],
      positionDifficulty: [
        { label: "A（容易）", value: "A" },
        { label: "B（一般）", value: "B" },
        { label: "C（难）", value: "C" },
      ],
      positionType: [
        { label: "公开职位", value: "PUBLIC" },
        { label: "自营职位", value: "PRIVATE" },
      ],
      majorDataoptions: [], //所学专业
      majorDataoptions_value: [],
      majordisabled: false,
      majorchecked: false,
      interview: { keys: [0] },
      sellPointTags: [
        "反馈速度快",
        "流程短",
        "付款快",
        "HR专业度高",
        "HR职位推动性强",
        "猎头供应商少，竞争小",
        "融资金额大",
        "一次性付款",
        "工作强度适中",
        "发展空间大",
        "offer流程快",
        "行业排名靠前",
      ],
      selectedSellPointTags: [], //职位卖点选中
      reasonTags: ["新增", "替换"],
      selectedReasonTags: [], //理由选中
      reasons: [
        { label: "不限", value: "0" },
        { label: "博士", value: "2" },
        { label: "MBA/EMBA", value: "3" },
      ],
      zodiac: [
        "鼠",
        "牛",
        "虎",
        "兔",
        "龙",
        "蛇",
        "马",
        "羊",
        "猴",
        "鸡",
        "狗",
        "猪",
      ],
      firstObjective: [],
      secondObjective: [],
      dataCompanyNameList: [],
      dataCharge: [],
      showCommission: false,
      firstCompanyName: "",
      secondCompanyName: "",
      dataFirstCompanyName: [],
      dataSecondCompanyName: [],
      is_reward_type: "0",
      companyName: "",
      companyId: "",
      hrList: [],
      productList: [],
      baseURL: baseURL,
      file: [],
      attachment_ids: [],
      fileList: [],
      get_post: false,
      showAffix: false,
      addTags: false,
      tagsValue: "",
      tagsReasonValue: "",
      addTagLoading: false,
      addReasonTags: false,
      showSkillTag: false,
      flag: true, // 保存职位按钮锁
      salaryStructureOther: false,
      socialBenefitsOther: false,
      liveBenefitsOther: false,
      vacationBenefitsOther: false,
      trafficBenefitsOther: false,
      showMorePortrait: false,
      inactiveBorn_name: [],
      activeBorn_name: [],
      skillsTag: [],
    };
  },
  beforeCreate() {

    this.form = this.$form.createForm(this);
  },
  created() {
    this.major();
    // document.addEventListener('visibilitychange', this.handleVisiable)
    // this.showAIAlert = false;
  },
  // show(){
  //   this.showAIAlert = false;
  // },
  beforeRouteEnter(to, from, next) {
    // 在路由切换进入组件时调用
    // 可以在这里执行需要的操作，如发送请求、保存数据等
    console.log('sky log beforeRouteEnter');
    // this.showAIAlert = false;
    next(vm => {
      // 在回调函数中可以访问到组件实例 vm
      vm.showAIAlert = false;
    });
  },
  mounted() {

    this.post_id = this.$route.query.postId;
    this.$nextTick(() => {
      this.form.setFieldsValue({ hunter_commission_type: "1" });
    });
    if (this.$route.query.postId) {
      this.getPost();
    }
    this.loadData("nation");
    this.loadData("post");
    this.loadData("industry");

    this.getWindowWidth(); // 在组件挂载后获取窗口宽度
    window.addEventListener("resize", this.getWindowWidth); // 添加窗口大小变化的事件监听

  },
  activated() {

    console.log(this.$route);
    if (this.$route.query.type) {
      a = 0;
      this.interview = { keys: [0] };
      this.form.resetFields();
      this.firstObjective = [];
      this.secondObjective = [];
      this.selectedSellPointTags = [];
      this.selectedReasonTags = [];
      this.fileList = [];
      this.attachment_ids = [];
      this.post_id = null;
      this.job_areas = [];
      this.job_industrys = [];
      this.$nextTick(() => {
        this.form.setFieldsValue({ hunter_commission_type: "1" });
      });
    }
    if (this.$route.query.postId) {
      a = 0;
      this.interview = { keys: [0] };
      this.post_id = this.$route.query.postId;
      this.form.resetFields();
      !this.get_post && this.getPost();
    }
  },
  computed: {
    ...mapState(["token", "config"]),
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth); // 组件销毁前移除事件监听
  },
  methods: {
    getWindowWidth() {
      this.windowWidth = window.innerWidth; // 获取窗口宽度
    },
    major() {
      Api.common.getmajortree().then((res) => {
        this.majorDataoptions = res.tree;
        console.log(res);
      });
    },
    filling(val){//一键填充
      this.showAIAlert = false;
      console.log("sky log");
      console.log(val);
      if (this.aiContentType == "1"){// 工作内容
        this.form.setFieldsValue({ requirements: val });
        this.workLength = val.length;
      }else if (this.aiContentType == "2"){
        this.form.setFieldsValue({ description: val });
      }
    },
    closeAct(event){
      this.showAIAlert = false;
    },
    getBenefitsMap(values, subKey) {
      let benefit = '';
      if (values && values.salary_benefits && values.salary_benefits[subKey] && values.salary_benefits[subKey].sels) {
        benefit = values.salary_benefits[subKey].sels.join(',');
      }
      return benefit;
    },

    showAIDialog(type) {
      let values = this.form.getFieldsValue();
      // 传给AI的JSON文件
      const jsonMap = new Map();
      /** 公司相关信息 */
      // 公司名称
      let company_name = this.companyName;
      // HR 名称
      let hr_name;
      const matchedHR = this.hrList.find(item => item.id === this.form.getFieldValue("company_contacter_id"));
      if (matchedHR) {
        hr_name =  matchedHR.name;
      }
      // 所属产品
      let product_name = this.form.getFieldValue("product_name");

      if (company_name){
        jsonMap.set('公司名称', company_name);
      }
     if (hr_name) {
       jsonMap.set('负责HR', hr_name);
     }
     if (product_name){
       jsonMap.set('所属产品', product_name);
     }
      /** 职位基本信息 */
      // 职位名称
      let job_name = values.name;

      // 职能类型
      let funcName = "";
      let funcArr = [];
      if (values && values.category_id) {
        const categoryIds = values.category_id.slice(); // 检查并复制 category_id 数组
        this.functionId.forEach((item) => {
          if (item.id && item.id == categoryIds[0]) {
            item.name && funcArr.push(item.name);
            item.children && item.children.forEach((itemTwo) => {
              if (itemTwo.id == categoryIds[1]) {
                itemTwo.name && funcArr.push(itemTwo.name);
                itemTwo.children && itemTwo.children.forEach((itemThree) => {
                  if (itemThree.id == categoryIds[2]) {
                    itemThree.name && funcArr.push(itemThree.name);
                    itemThree.children && itemThree.children.forEach((itemFour) => {
                      if (itemFour.id == categoryIds[3]) {
                        itemThree.name && funcArr.push(itemFour.name);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
      if (funcArr.length > 0){
        // 在此处处理 funcArr 数组
        funcName = funcArr.join(',');
        job_name = funcArr.pop();
      }
      jsonMap.set('职位名称', job_name);
      jsonMap.set('职能类型', funcName);

      let jobAreas = this.$refs.cityCascader.getCheckedNodes();
      //工作地点
      let addresses = [];
      jobAreas.forEach((x) => {
        addresses.push([...x.pathLabels]);
      });
      let address = "";
      if (addresses.length > 0){
        // 在此处处理 funcArr 数组
        address = addresses.join(',');
      }
      jsonMap.set('工作地点', address);
      // 招聘人数
      jsonMap.set('招聘人数',values.quantity);
      // 薪资范围
      if (values.hunter_salary_min && values.hunter_salary_max){
         jsonMap.set("薪资范围",values.hunter_salary_min + '-' + values.hunter_salary_max + '万/年');
      }
      // 薪资制度
      jsonMap.set('薪资制度',values.salary_type);
      // 试用期薪资比例
      jsonMap.set('试用期薪资比例',values.probationary_salary_ratio);
      // 职位级别
      jsonMap.set('职位级别',values.level);
      // 平级情况
      jsonMap.set('平级情况',values.samelevel);
      // 下属团队
      jsonMap.set('下属团队',values.subordinate_team);

      /** 薪资福利 */
      // 税前薪资
     let pre_salary_min = values.salary_benefits.pre_tax_salary.min;
     let pre_salary_max = values.salary_benefits.pre_tax_salary.max;
     let pre_salary_month_count = values.salary_benefits.pre_tax_salary.month_count;

      if (pre_salary_min && pre_salary_max && pre_salary_month_count){
        jsonMap.set('税前薪资','(' + pre_salary_min + 'K-' + pre_salary_max + 'K)' + '*' + pre_salary_month_count);
      }
      jsonMap.set('薪资构成', this.getBenefitsMap(values,'salary_structure'));
      jsonMap.set('社保福利', this.getBenefitsMap(values,'social_benefits'));
      jsonMap.set('居住福利', this.getBenefitsMap(values,'live_benefits'));
      jsonMap.set('年假福利', this.getBenefitsMap(values,'vacation_benefits'));

      //通讯交通
      let txjt = '';
      if (values && values.salary_benefits && values.salary_benefits.traffic_benefits && values.salary_benefits.traffic_benefits.sels) {
        txjt = values.salary_benefits.traffic_benefits.sels;
      }
      jsonMap.set('通讯交通',txjt);

      console.log("sky log");
      console.log(jsonMap);
      this.aiJsonData = jsonMap;
      this.showAIAlert = true;
      // 在这里处理AI一键生成推荐语，并根据type参数执行不同的逻辑操作
      if (type === 'work') {
        // 根据推荐语类型生成推荐语
        console.log('工作要求');
        this.aiContentType = "1";
      } else {
        // 执行其他逻辑操作
        console.log('任职要求');
        this.aiContentType = "2";
      }

    },
    handleChange(value) {
      this.majorDataoptions_value = [];
      value.length > 0 ? this.majorDataoptions_value.push(value[0]) : null;
      value.length > 1 ? this.majorDataoptions_value.push(value[1]) : null;
      value.length > 2 ? this.majorDataoptions_value.push(value[2]) : null;
      console.log(this.majorDataoptions_value);
    },
    majorChange(value) {
      this.majordisabled = value.target.checked;
      if (this.majordisabled) {
        this.majorDataoptions_value = ["0", "0", "0"];
      } else {
        this.majorDataoptions_value = [];
      }
      console.log(value.target.checked);
    },
    selectFuncName(value, opt) {
      this.name = opt.data.attrs.text;
      let category_id = value.split(",");
      this.form.setFieldsValue({ category_id: category_id });
      this.visibleFunction();
    },
    changeFuncName(value) {
      if (value.length > 0) {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          Api.common.getFuncName({ name: value }).then((res) => {
            this.funcNameData = res.list;
          });
        }, 1000);
      }
    },
    changeIndustry(val) {
      if (val.length > 5) {
        this.$message.warning("行业类型最多选五个！");
        // this.job_industrys = [];
        this.job_industrys = this.job_industrys.slice(0, 5);
      }
      console.log(val);
    },
    changeWorkCity(val) {
      if (val.length > 3) {
        this.$message.warning("工作地点最多选三个！");
        this.job_areas = this.job_areas.slice(0, 3);
      }
      // console.log(this.workCity);
    },
    changeInactiveBorn(value, opt) {
      console.log(value, opt);
      this.inactiveBorn_name = opt;
    },
    changeActiveBorn(value, opt) {
      this.activeBorn_name = opt;
    },
    onChangeOther1(e) {
      this.salaryStructureOther = e.target.checked;
    },
    onChangeOther2(e) {
      this.socialBenefitsOther = e.target.checked;
    },
    onChangeOther3(e) {
      this.liveBenefitsOther = e.target.checked;
    },
    onChangeOther4(e) {
      this.vacationBenefitsOther = e.target.checked;
    },
    onChangeOther5(e) {
      this.trafficBenefitsOther = e.target.checked;
    },
    verificationFun(rule, value, callback) {
      if (this.is_reward_type === "1") {
        if (!value) {
          return callback(true);
        } else {
          callback();
        }
      } else {
        return callback();
      }
    },
    verificationFunTwo(rule, value, callback) {
      if (this.is_reward_type === "0") {
        if (!value) {
          return callback(true);
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    async loadData(type) {
      let data = this.list[type];
      let response;
      try {
        response = await Api.common[data.fun]();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      if (type == "nation") {
        this.workCity = [...response[data.key]];
        this.area = this.joinData(response[data.key]);
      } else if (type == "post") {
        this.functionId = this.joinData(response[data.key]);
      } else {
        this.industry = this.joinData(response[data.key]);
        this.jobIndustry = [...response[data.key]];
      }
    },
    joinData(data) {
      let init = this.area;
      return [{ ...init }, ...data];
    },
    handleteamLength(e) {
      this.teamLength = e.target.value.length;
    },
    handleWorkLength(e) {
      this.workLength = e.target.value.length;
    },
    handleProgressLength(e) {
      this.progressLength = e.target.value.length;
    },
    handleRefundLength(e) {
      this.refundLength = e.target.value.length;
    },
    handlePolicy(e){
      this.policyLength = e.target.value.length
    },
    addInterview() {
      //新增面试流程
      const keys = this.interview.keys;
      this.interview.keys = keys.concat(++a);
    },
    deleteInterview(index) {
      //删除面试流程
      this.interview.keys.splice(index, 1);
    },
    addSellingPoint() {
      this.addTags = true;
    },
    addReasons() {
      this.addReasonTags = true;
    },
    cancelTags() {
      this.addTags = false;
    },
    cancelReasonTags() {
      this.addReasonTags = false;
    },
    addReasonTagsModal() {
      this.addTagLoading = true;
      this.reasonTags.push(this.tagsReasonValue);
      this.addTagLoading = false;
      this.addReasonTags = false;
    },
    addTagsModal() {
      this.addTagLoading = true;
      this.sellPointTags.push(this.tagsValue);
      this.addTagLoading = false;
      this.addTags = false;
    },
    handleChangeTags(tag, checked) {
      //职位卖点
      const { selectedSellPointTags } = this;
      const nextSelectedTags = checked
        ? [...selectedSellPointTags, tag]
        : selectedSellPointTags.filter((t) => t !== tag);
      console.log("You are interested in: ", nextSelectedTags);
      this.selectedSellPointTags = nextSelectedTags;
    },
    handleReasonChangeTags(tag, checked) {
      //招聘原因
      const { selectedReasonTags } = this;
      const nextSelectedTags = checked
        ? [...selectedReasonTags, tag]
        : selectedReasonTags.filter((t) => t !== tag);
      console.log("You are interested in: ", nextSelectedTags);
      this.selectedReasonTags = nextSelectedTags;
    },
    onAddFirstCompany() {
      if (this.firstObjective.length === 3) {
        this.$message.info("最多只能添加三个");
      } else if (this.firstCompanyName) {
        this.searchProducts(this.firstCompanyName).then((values) => {
          let productList = [];
          let productListall = [];
          let name = this.firstCompanyName;
          values.list &&
            values.list.forEach((item) => {
              productList.push(item.product_name);
              productListall.push(item);
            });
          this.firstObjective.push({
            company_name: name,
            productList: productList,
            productListall: productListall,
            selectedProductList: [],
            notes: "",
          });
          this.firstCompanyName = "";
        });
      }
    },
    searchProducts(value) {
      return Api.common.searchProducts({ keyword: value }).then((res) => {
        return res;
      });
    },
    getHR() {
      this.hrList = [];
      if (this.companyId) {
        Api.common
          .searchCompanyHr({ hr_company_id: this.companyId })
          .then((res) => {
            let keys = Object.keys(res.contacters);
            if (keys.length > 0) {
              keys.forEach((item) => {
                this.hrList.push({
                  name: res.contacters[item].hr_name,
                  id: res.contacters[item].id,
                });
              });
            }
          });
      } else {
        this.$message.info("请先填写公司！");
      }
    },
    getProduct() {
      this.productList = [];
      if (this.companyName) {
        Api.common.searchProducts({ keyword: this.companyName }).then((res) => {
          res.list.length > 0 &&
            res.list.forEach((item) => {
              this.productList.push({ name: item.product_name });
            });
        });
      } else {
        this.$message.info("请先填写公司！");
      }
    },
    onAddSecondCompany() {
      if (this.secondObjective.length === 3) {
        this.$message.info("最多只能添加三个");
      } else if (this.secondCompanyName) {
        this.searchProducts(this.secondCompanyName).then((values) => {
          let productList = [];
          let productListall = [];
          let name = this.secondCompanyName;
          values.list &&
            values.list.forEach((item) => {
              productList.push(item.product_name);
              productListall.push(item);
            });
          this.secondObjective.push({
            company_name: name,
            productList: productList,
            productListall: productListall,
            selectedProductList: [],
            notes: "",
          });
          this.secondCompanyName = "";
        });
      }
    },
    handleChangeProduct(tag, checked, i) {
      const selectedProductList = this.firstObjective[i].selectedProductList;
      const nextSelectedTags = checked
        ? [...selectedProductList, tag]
        : selectedProductList.filter((t) => t !== tag);
      if (nextSelectedTags.length === 4) {
        this.$message.info("最多只能添加三个");
      } else {
        this.firstObjective[i].selectedProductList = nextSelectedTags;
      }
    },
    handleChangeSecondProduct(tag, checked, i) {
      const selectedProductList = this.secondObjective[i].selectedProductList;
      const nextSelectedTags = checked
        ? [...selectedProductList, tag]
        : selectedProductList.filter((t) => t !== tag);
      if (nextSelectedTags.length === 4) {
        this.$message.info("最多只能添加三个");
      } else {
        this.secondObjective[i].selectedProductList = nextSelectedTags;
      }
    },
    deleteSecondCompany(i) {
      this.secondObjective.splice(i, 1);
    },
    deleteFirstCompany(i) {
      this.firstObjective.splice(i, 1);
    },
    getSuggestApi(value) {
      Api.post.getSuggest({ name: value }).then((res) => {
        const data = [];
        res.forEach((item) => {
          data.push({
            text: item.name,
            value: item.uid,
            tel: item.tel,
          });
        });
        this.dataCharge = data;
      });
    },
    handleChangeCharge(value) {
      this.form.setFieldsValue({ post_tel: "" });
      if (value.length >= 2) {
        this.debounce(() => this.getSuggestApi(value), 1000);
      }
    },
    selectPostLeader(value, option) {
      this.dataCharge.forEach((item) => {
        if (item.value == value) {
          this.$nextTick(() => {
            this.form.setFieldsValue({ post_tel: item.tel });
          });
        }
      });
    },
    getCompanyInfoApi(value) {
      Api.post
        .getCompanyInfo({ company_name: value, audit_status: 2, is_sign: 1 })
        .then((res) => {
          const data = [];
          res.forEach((item) => {
            data.push({
              text: item.name,
              value: item.id,
            });
          });
          this.dataCompanyNameList = data;
        });
    },
    changeCompanyName(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getCompanyInfoApi(value), 1000);
      }
      if (value.length < 2) {
        this.productList = [];
        this.hrList = [];
      }
    },
    selectComId(value, option) {
      this.companyId = value;
      this.companyName = option.componentOptions.children[0].text;
      this.getProduct();
      this.getHR();
    },
    getCompanyListApi(value) {
      Api.common.getCompanyList({ keyword: value }).then((res) => {
        const data = [];
        res.list.forEach((item) => {
          data.push(item.name);
        });
        this.dataFirstCompanyName = data;
      });
    },
    getSecondCompanyListApi(value) {
      Api.common.getCompanyList({ keyword: value }).then((res) => {
        const data = [];
        res.list.forEach((item) => {
          data.push(item.name);
        });
        this.dataSecondCompanyName = data;
      });
    },
    changeFirstCompanyName(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getCompanyListApi(value), 1000);
      } else {
        this.dataFirstCompanyName = [];
      }
    },
    addCompanyData(value, options) {
      this.firstCompanyName = value;
      this.onAddFirstCompany();
    },
    addSecondCompanyData(value, options) {
      this.secondCompanyName = value;
      this.onAddSecondCompany();
    },
    debounce(fn, delay) {
      let self = this;
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(self);
      }, delay);
    },
    changeSecondCompanyName(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getSecondCompanyListApi(value), 1000);
      } else {
        this.dataSecondCompanyName = [];
      }
    },
    onChangeServiceMode(e) {
      this.serviceMode = e.target.value;
    },
    uploadChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.data.url;
        }
        return file;
      });
      this.fileList = fileList;
      console.log(fileList);
      const status = info.file.status;
      if (status !== "uploading") {
      }
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
        this.file = [];
        info.fileList.forEach((item) => {
          if (item.response && item.response.data) {
            this.file.push(JSON.stringify(item.response.data));
          } else {
            this.attachment_ids.push(item.id);
          }
        });
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败！`);
      }
    },
    handleChangeCommission(e) {
      if (e == "1") {
        this.showCommission = false;
      } else {
        this.showCommission = true;
      }
    },
    onPreview() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.previewData(values).then((data) => {
            data = JSON.stringify(data);
            this.$router.push({
              path: "/post-preview",
              name: "post-preview",
              params: {
                values: data,
                type: this.$route.query.postId ? "" : "createPreview",
              },
            });
          });
        }
      });
    },
    async getPost() {
      this.get_post = true;
      let res = await Api.post.getPostInfo({ job_id: this.post_id });
      this.firstObjective = [];
      this.secondObjective = [];
      this.selectedSellPointTags = [];
      this.selectedReasonTags = [];
      this.fileList = [];
      this.attachment_ids = [];
      this.majorDataoptions_value = [];
      if (res.job.resume_first_major_id != "0") {
        this.majorDataoptions_value.push(res.job.resume_first_major_id);
        if (res.job.resume_second_major_id != "0") {
          this.majorDataoptions_value.push(res.job.resume_second_major_id);
          if (res.job.resume_third_major_id != "0") {
            this.majorDataoptions_value.push(res.job.resume_third_major_id);
          }
        }
      } else {
        this.majordisabled = true;
        this.majorchecked = true;
      }
      this.pushForm(res.job).then((values) => {
        this.$nextTick(() => {
          console.log(values, "valuesvaluesvalues");
          this.form.setFieldsValue(values);
          this.visibleFunction();
          this.get_post = false;
        });
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFieldsAndScroll((err, values) => {
        console.log(values.name, this.name);
        console.log(values, "valuesvaluesvaluesvaluesvaluesvalues");
        if (!err) {
          if (
            that.firstObjective.length == 0 &&
            that.secondObjective.length == 0 &&
            that.directions == ""
          ) {
            that.$message.info("搜寻方向必须填写一项");
            return;
          }
          if (that.flag) {
            that.flag = false;
            that.saveData(values).then((values) => {
              console.log(values, "params");

              if (that.$route.query.id) {
                values.job_clue_id = that.$route.query.id;
              }
              if (that.post_id) {
                values.id = that.post_id;
                Api.post
                  .editPost(values)
                  .then((res) => {
                    // that.$message.info("编辑成功！");
                    that.flag = true;
                    that.$router.push({
                      path: "/post-supplement",
                      query: {
                        job_id: this.post_id,
                        headhunting: true,
                      },
                    });
                  })
                  .catch((err) => {
                    that.flag = true;
                    console.log(err);
                  });
              } else {
                Api.post
                  .savePost(values)
                  .then((res) => {
                    that.flag = true;
                    // that.$message.info("保存成功！");
                    // that.$router.push({
                    //   path: "/hunter-post"
                    // });
                    that.$router.push({
                      path: "/post-supplement",
                      query: {
                        job_id: res.job_id,
                        headhunting: true,
                      },
                    });
                  })
                  .catch((err) => {
                    that.flag = true;
                    console.log(err);
                  });
              }
            });
          }
        }
      });
    },
    saveData(data) {
      let values = data;
      console.log(values, "previewValues");
      return new Promise((resolve, reject) => {
        if (values.name.indexOf(",") >= 0) {
          values.name = this.name;
        }
        console.log(values.name, "values.name"); //职位名称；
        if (this.majorchecked) {
          values.resume_first_major_id = "0";
          values.resume_second_major_id = "0";
          values.resume_third_major_id = "0";
        } else {
          values.resume_first_major_id =
            this.majorDataoptions_value.length > 0
              ? this.majorDataoptions_value[0]
              : "0";
          values.resume_second_major_id =
            this.majorDataoptions_value.length > 1
              ? this.majorDataoptions_value[1]
              : "0";
          values.resume_third_major_id =
            this.majorDataoptions_value.length > 2
              ? this.majorDataoptions_value[2]
              : "0";
        }
        values.product_name = JSON.stringify(values.product_name);
        values.is_reward_type = this.is_reward_type;
        values.company_id = this.companyId;
        //工作地点
        values.job_areas = [];
        this.job_areas.forEach((item) => {
          values.job_areas.push({
            province_id: item[0],
            city_id: item[1],
            dist_id: item[2],
          });
        });

        //行业
        values.job_industrys = [];
        this.job_industrys.forEach((item) => {
          values.job_industrys.push({
            first_industry_id: item[0],
            second_industry_id: item[1],
            third_industry_id: item[2],
            fourth_industry_id: item[3],
          });
        });
        values.job_areas = JSON.stringify(values.job_areas);
        values.job_industrys = JSON.stringify(values.job_industrys);

        // 职能
        values.first_category_id = data.category_id[0];
        values.second_category_id = data.category_id[1];
        values.third_category_id = data.category_id[2];
        values.fourth_category_id = data.category_id[3];

        values.attachments = this.file;
        values.attachment_ids = this.attachment_ids;
        values.selling_point_tags = JSON.stringify(this.selectedSellPointTags);
        values.recruitment_reason_tags = JSON.stringify(
          this.selectedReasonTags
        );
        // 处理画像出生地
        values.draw_portrait_inactive_tag.inactive_born_province_id =
          values.inactive_born && values.inactive_born[0];
        values.draw_portrait_inactive_tag.inactive_born_city_id =
          values.inactive_born && values.inactive_born[1];
        values.draw_portrait_inactive_tag.inactive_born_dist_id =
          values.inactive_born && values.inactive_born[2];

        values.draw_portrait_inactive_tag.inactive_born_province_name =
          this.inactiveBorn_name.length && this.inactiveBorn_name[0].name;
        values.draw_portrait_inactive_tag.inactive_born_city_name =
          this.inactiveBorn_name.length && this.inactiveBorn_name[1].name;
        values.draw_portrait_inactive_tag.inactive_born_dist_name =
          this.inactiveBorn_name.length && this.inactiveBorn_name[2].name;

        values.draw_portrait_active_tag.active_born_province_id =
          values.active_born && values.active_born[0];
        values.draw_portrait_active_tag.active_born_city_id =
          values.active_born && values.active_born[1];
        values.draw_portrait_active_tag.active_born_dist_id =
          values.active_born && values.active_born[2];

        values.draw_portrait_active_tag.active_born_province_name =
          this.activeBorn_name.length && this.activeBorn_name[0].name;
        values.draw_portrait_active_tag.active_born_city_name =
          this.activeBorn_name.length && this.activeBorn_name[1].name;
        values.draw_portrait_active_tag.active_born_dist_name =
          this.activeBorn_name.length && this.activeBorn_name[2].name;
        // let language_requirement = [];
        // values.language_requirement.forEach( x => {
        //   language_requirement.push({ name: x });
        // })
        values.language_requirement = JSON.stringify(
          values.language_requirement
        );
        values.salary_benefits = JSON.stringify(values.salary_benefits);
        values.draw_portrait_inactive_tag = JSON.stringify(
          values.draw_portrait_inactive_tag
        );
        values.draw_portrait_active_tag = JSON.stringify(
          values.draw_portrait_active_tag
        );

        let direction_companys = [];
        this.firstObjective.forEach((item) => {
          const products = [];
          item.productListall.forEach((items) => {
            if (item.selectedProductList.indexOf(items.product_name) > -1) {
              items.domain = items.product_domain;
              items.name = items.product_name;
              items.tags = items.product_tags;
              products.push(items);
            }
          });
          direction_companys.push({
            company_name: item.company_name,
            intention_order: 1,
            notes: item.notes,
            products: products,
          });
        });
        this.secondObjective.forEach((item) => {
          const products = [];
          item.productListall.forEach((items) => {
            if (item.selectedProductList.indexOf(items.product_name) > -1) {
              items.domain = items.product_domain;
              items.name = items.product_name;
              items.tags = items.product_tags;
              products.push(items);
            }
          });
          direction_companys.push({
            company_name: item.company_name,
            intention_order: 2,
            notes: item.notes,
            products: products,
          });
        });
        console.log(direction_companys, "direction_companys");
        values.direction_companys = JSON.stringify(direction_companys);
        delete values.category_id;
        delete values.inactive_born;
        delete values.active_born;
        resolve(values);
      });
    },
    previewData(data) {
      let values = data;
      return new Promise((resolve, reject) => {
        values.companyName = this.companyName;
        values.company_id = this.companyId;
        this.hrList.forEach((item) => {
          //负责HR
          if (item.id === data.company_contacter_id) {
            values.HR_name = item.name;
          }
        });
        this.functionId.forEach((item) => {
          if (item.id && item.id == values.category_id[0]) {
            values.first_category_name = item.name;
            item.children && item.children.forEach((itemTwo) => {
                if (itemTwo.id == values.category_id[1]) {
                  values.second_category_name = itemTwo.name;
                  itemTwo.children && itemTwo.children.forEach((itemThree) => {
                      if (itemThree.id == values.category_id[2]) {
                        values.third_category_name = itemThree.name;
                        itemThree.children && itemThree.children.forEach((itemFour) => {
                            if (itemFour.id == values.category_id[3]) {
                              values.fourth_category_name = itemFour.name;
                            }
                          });
                      }
                    });
                }
              });
          }
        });
        let jobAreas = this.$refs.cityCascader.getCheckedNodes();
        let industryAreas = this.$refs.industryCascader.getCheckedNodes();
        //工作地点
        values.job_areas = [];
        jobAreas.forEach((x) => {
          values.job_areas.push([...x.pathLabels]);
        });

        //行业
        values.job_industrys = [];
        industryAreas.forEach((x) => {
          values.job_industrys.push([...x.pathLabels]);
        });
        console.log(values.job_areas, values.job_industrys);

        values.is_reward_type = this.is_reward_type;
        values.attachments = this.file;
        let direction_companys = [];
        this.firstObjective.forEach((item) => {
          const products = [];
          item.productListall.forEach((items) => {
            if (item.selectedProductList.indexOf(items.product_name) > -1) {
              items.domain = items.product_domain;
              items.name = items.product_name;
              items.tags = items.product_tags;
              products.push(items);
            }
          });
          direction_companys.push({
            company_name: item.company_name,
            intention_order: 1,
            notes: item.notes,
            products: products,
          });
        });
        this.secondObjective.forEach((item) => {
          const products = [];
          item.productListall.forEach((items) => {
            if (item.selectedProductList.indexOf(items.product_name) > -1) {
              items.domain = items.product_domain;
              items.name = items.product_name;
              items.tags = items.product_tags;
              products.push(items);
            }
          });
          direction_companys.push({
            company_name: item.company_name,
            intention_order: 2,
            notes: item.notes,
            products: products,
          });
        });
        values.direction_companys = direction_companys;
        values.selectedSellPointTags = this.selectedSellPointTags;
        values.selectedReasonTags = this.selectedReasonTags;
        delete values.category_id;
        resolve(values);
      });
    },
    pushForm(data) {
      return new Promise((resolve, reject) => {
        console.log(data, "datatddadadas");
        var values = {};
        this.dataCompanyNameList = [
          {
            text: data.company.name,
            value: data.company.id,
          },
        ];
        values.company_id = data.company.id || ""; //公司名
        values.companyName = data.company.name;
        this.companyName = data.company.name;
        this.companyId = data.company.id;
        this.getProduct();
        this.getHR();
        if (data.product_name.indexOf("[") == -1) {
          //所属产品
          values.product_name = data.product_name;
        } else {
          values.product_name = JSON.parse(data.product_name) || "";
        }
        values.company_contacter_id = data.company_contacter_id || ""; //负责HR
        values.name = data.name || ""; //职位名
        this.name = data.name || ""; //职位名
        values.category_id = []; //职能类型
        values.category_id[0] = data.first_category_id || null;
        values.category_id[1] = data.second_category_id || null;
        values.category_id[2] = data.third_category_id || null;
        // 工作地点
        this.job_areas = [];
        data.job_areas &&
          data.job_areas.forEach((item) => {
            this.job_areas.push([item.province_id, item.city_id, item.dist_id]);
          });
        // 行业
        this.job_industrys = [];
        data.job_industrys &&
          data.job_industrys.forEach((item) => {
            let arr = [
              item.first_industry_id,
              item.second_industry_id,
              item.third_industry_id,
              item.fourth_industry_id,
            ];
            if (item.fourth_industry_id == 0) arr.length = 3;
            this.job_industrys.push(arr);
          });
        // values.location = []; //工作地点
        // values.location[0] = data.province_id; //所在地
        // values.location[1] = data.city_id; //所在地
        // values.location[2] = data.dist_id; //所在地

        values.quantity = data.quantity || ""; //招聘人数
        values.hunter_salary_min = data.hunter_salary_min || ""; //薪资下限
        values.hunter_salary_max = data.hunter_salary_max || ""; //薪资上限
        values.salary_type = data.salary_type || ""; //薪资制度
        values.probationary_salary_ratio = data.probationary_salary_ratio || ""; //试用期薪资比例
        values.level = data.level || ""; //职位级别
        values.samelevel = data.samelevel || ""; //平级情况
        values.subordinate_team = data.subordinate_team || ""; //下属团队
        values.requirements = data.requirements || ""; //工作内容
        values.description = data.description || ""; //任职要求
        values.gender_id = data.gender_id || ""; //性别要求
        values.experience_id = data.experience_id || ""; //工作经验
        values.education_id = data.education_id || ""; //学历要求
        values.full_time_type = data.full_time_type || ""; //是否统招
        values.school_type = data.school_type || ""; //学校类型
        values.interviews = []; //面试流程
        values.requirement_skill = data.requirement_skill; //技能

        if (data.job_interviews.length > 0) {
          data.job_interviews.forEach((item, i) => {
            if (i > 0) {
              this.addInterview();
            }
            values.interviews[i] = item.content;
          });
        }
        data.selling_point_tags.forEach((item) => {
          if (this.sellPointTags.indexOf(item) === -1) {
            this.sellPointTags.push(item);
          }
        });
        this.selectedSellPointTags = data.selling_point_tags || []; //职位卖点
        data.recruitment_reason_tags.forEach((item) => {
          if (this.reasonTags.indexOf(item) === -1) {
            this.reasonTags.push(item);
          }
        });
        this.selectedReasonTags = data.recruitment_reason_tags || ""; //招聘原因
        this.firstObjective = [];
        this.$nextTick().then(() => {
          data.first_seek_companys &&
            data.first_seek_companys.forEach((item, i) => {
              this.searchProducts(item.company_name).then((values) => {
                let productList = [];
                let productListall = [];
                let selectedProductList = [];
                values.list &&
                  values.list.forEach((item) => {
                    productList.push(item.product_name);
                    productListall.push(item);
                  });
                item.seek_products &&
                  item.seek_products.forEach((item) => {
                    selectedProductList.push(item.name);
                  });
                this.firstObjective.push({
                  company_name: item.company_name,
                  productList: productList,
                  productListall: productListall,
                  selectedProductList: selectedProductList,
                  notes: item.notes,
                });
              });
            });
        });
        data.second_seek_companys &&
          data.second_seek_companys.forEach((item, i) => {
            this.searchProducts(item.company_name).then((values) => {
              let productList = [];
              let productListall = [];
              let selectedProductList = [];
              values.list &&
                values.list.forEach((item) => {
                  productList.push(item.product_name);
                  productListall.push(item);
                });
              item.seek_products &&
                item.seek_products.forEach((item) => {
                  selectedProductList.push(item.name);
                });
              this.secondObjective.push({
                company_name: item.company_name,
                productList: productList,
                productListall: productListall,
                selectedProductList: selectedProductList,
                notes: item.notes,
              });
            });
          });
        if (data.attachments.length > 0) {
          data.attachments.forEach((item, i) => {
            console.log(item);
            item.url = item.file_url;
            item.name = item.file_name;
            item.status = "done";
            item.uid = String(i - 60);
            this.fileList.push(item);
            this.attachment_ids.push(item.id);
          });
        }
        console.log(this.fileList);
        values.directions = data.directions || ""; //搜寻方向其他要求
        values.recruitment_progress = data.recruitment_progress || ""; //职位进展
        values.num_published_platforms = data.num_published_platforms || ""; //甲方委托猎企数
        values.open_duration = data.open_duration || ""; //面上社会已开发时长
        values.urgency_level = data.urgency_level || ""; //职位紧急程度
        values.grade = data.grade || ""; //职位难度
        //服务方式
        this.is_reward_type = data.is_reward_type;
        //签约佣金
        values.hunter_commission_type = data.hunter_commission_type || ""; //佣金模式
        if (data.hunter_commission_type == "1") {
          this.showCommission = false;
        } else {
          this.showCommission = true;
        }
        values.reward_amount = data.reward_amount || ""; //悬赏金额
        values.reward_policy = data.reward_policy || ""; //悬赏政策
        values.hunter_commission_value = data.hunter_commission_value || ""; //佣金值
        values.probation = data.probation || ""; //保证期
        values.payment_info = data.payment_info || ""; //与退款细则
        this.refundLength = data.payment_info.length
        this.policyLength = data.platform_policy.length
        values.platform_policy = data.platform_policy
        values.age_requirement = data.age_requirement || ""; //年龄要求
        // if
        values.ie_user_id = data.ie_user.uid || ""; //职位负责人
        this.dataCharge = [
          {
            text: data.ie_user.name,
            value: data.ie_user.uid,
            tel: data.ie_user.tel,
          },
        ];
        values.post_tel = data.ie_user.tel || ""; //职位负责人电话
        values.type = data.type || ""; //职位类型

        values.age_requirement_min = data.age_requirement_min || "";
        values.age_requirement_max = data.age_requirement_max || "";
        values.major_requirement = data.major_requirement || "";

        values.language_requirement =
          (data.language_requirement &&
            JSON.parse(data.language_requirement)) ||
          [];

        // values.Industry = []; //专业类型
        // values.Industry[0] = data.first_industry_id || null;
        // values.Industry[1] = data.second_industry_id || null;
        // values.Industry[2] = data.third_industry_id || null;
        // values.Industry[3] = data.fourth_industry_id || null;

        values.salary_benefits =
          data.salary_benefits && JSON.parse(data.salary_benefits);
        values.draw_portrait_inactive_tag =
          data.draw_portrait_inactive_tag &&
          JSON.parse(data.draw_portrait_inactive_tag);
        values.draw_portrait_active_tag =
          data.draw_portrait_active_tag &&
          JSON.parse(data.draw_portrait_active_tag);
        values.inactive_born = [];
        values.active_born = [];
        values.inactive_born[0] =
          values.draw_portrait_inactive_tag.inactive_born_province_id; //所在地
        values.inactive_born[1] =
          values.draw_portrait_inactive_tag.inactive_born_city_id; //所在地
        values.inactive_born[2] =
          values.draw_portrait_inactive_tag.inactive_born_dist_id; //所在地
        values.active_born[0] =
          values.draw_portrait_active_tag.active_born_province_id || null;
        values.active_born[1] =
          values.draw_portrait_active_tag.active_born_city_id || null;
        values.active_born[2] =
          values.draw_portrait_active_tag.active_born_dist_id || null;

        this.inactiveBorn_name = [
          {
            name: values.draw_portrait_inactive_tag.inactive_born_province_name,
          },
          { name: values.draw_portrait_inactive_tag.inactive_born_city_name },
          { name: values.draw_portrait_inactive_tag.inactive_born_dist_name },
        ];
        this.activeBorn_name = [
          { name: values.draw_portrait_active_tag.active_born_province_name },
          { name: values.draw_portrait_active_tag.active_born_city_name },
          { name: values.draw_portrait_active_tag.active_born_dist_name },
        ];
        resolve(values);
      });
    },
    affixChange(affixed) {
      this.showAffix = affixed;
    },
    goCompany() {
      this.$router.push({
        path: "/client-manage",
      });
    },
    async visibleFunction() {
      let category_id = this.form.getFieldValue("category_id");
      if (category_id && category_id.length) {
        let lastCategoryId = "";
        if (
          category_id[category_id.length - 1] &&
          category_id[category_id.length - 1] != 0
        ) {
          lastCategoryId = category_id[category_id.length - 1];
        } else {
          lastCategoryId =
            category_id[2] == 0
              ? category_id[1] == 0
                ? category_id[0]
                : category_id[1]
              : category_id[2];
        }
        console.log(lastCategoryId);
        let { skills } = await Api.common.getSkills({
          function_id: lastCategoryId,
        });
        this.showSkillTag = skills.length ? true : false;
        this.skillsTag = skills;
        console.log(skills);
      }
    },
    async showTagsModal(type) {
      let category_id = this.form.getFieldValue("category_id");
      console.log(category_id);
      if (!category_id) {
        this.$message.info("请先选择职能！");
        return false;
      }
      let selectSkills = this.form.getFieldValue(type);
      selectSkills = selectSkills && selectSkills.split(",");
      let lastCategoryId = "";
      if (
        category_id[category_id.length - 1] &&
        category_id[category_id.length - 1] != 0
      ) {
        lastCategoryId = category_id[category_id.length - 1];
      } else {
        lastCategoryId =
          category_id[2] == 0
            ? category_id[1] == 0
              ? category_id[0]
              : category_id[1]
            : category_id[2];
      }
      console.log(lastCategoryId);
      let { skills } = await Api.common.getSkills({
        function_id: lastCategoryId,
      });
      skills.forEach((item) => {
        item.is_default = "0";
      });
      this.skillsTag = skills;
      console.log(skills);
      if (skills.length != 0) {
        this.$refs.tagsModal.show(this.skillsTag, type);
      } else {
        this.$message.info("该职能类型下没有技能标签");
      }
    },
    updateSkills(skills, type) {
      // 处理skills选中的项目
      console.log(skills);
      let selectSkills = [];
      let str = "";
      selectSkills = selectSkills.concat(
        skills.filter((skill) => skill.is_default === "1")
      );
      selectSkills.forEach((item) => {
        str += item.skill_name + ",";
      });
      str = str.slice(0, str.length - 1);
      console.log(type + "-------", str);
      if (type === "requirement_skill") {
        this.form.setFieldsValue({ requirement_skill: str });
      } else {
        this.form.setFieldsValue({ recommend_skill: str });
      }
    },
  },
};
</script>

<style lang="scss">
.post-edit {
  //width: 1100px;
  //width: 1200px;
  width: 100%;
  padding-bottom: 50px;

  .resume-title {
    color: #000000;
    font-weight: bold;
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    text-align: left;
    margin-bottom: 40px;
  }

  .item-title {
    width: 150px;
    box-sizing: border-box;
    padding-right: 20px;
    text-align: right;
    white-space: nowrap;
  }

  .line {
    width: 3px;
    height: 16px;
    background: #35b5fe;
    margin-right: 10px;
    float: left;
  }

  .input-list {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 30px;
  }

  .input-list2 {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 30px;
  }

  .red-color {
    color: #fc5646;
  }

  .list-item {
    flex: 1;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #000000;
    font-size: 14px;

    .red-color {
      color: #fc5646;
    }

    .ant-input,
    .ant-calendar-picker {
      font-size: 14px;
    }

    .ant-input-lg {
      font-size: 14px;
    }

    input {
      font-size: 14px;
    }

    .ant-radio-group,
    .company {
      width: 340px;
    }

    .ant-radio-button-wrapper {
      border-radius: 4px;
      margin-left: 25px;
      border-left: 1px solid #d9d9d9;
      font-size: 14px;
      font-weight: 200;
      padding: 0 19px;
    }

    .ant-radio-group-solid
      .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      border-left: 0;
    }

    .ant-radio-button-wrapper:not(:first-child)::before {
      display: none;
    }

    .ant-radio-button-wrapper:first-child {
      margin-left: 0;
    }
  }

  .list-item span {
    /*color: rgba(0, 0, 0, 0.65);*/
    font-weight: 400;
  }

  .ant-cascader-picker,
  .marriage-select {
    width: 400px;
  }

  .ant-select-lg {
    font-weight: 400;
    font-size: 14px;
  }

  .ant-input-lg {
    font-size: 14px;
  }

  .text-arie {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;

    .count {
      color: #999;
      position: absolute;
      right: 15px;
      bottom: -8px;
    }
  }

  .text-arie-title {
    width: 130px;
    text-align: right;
    color: #000000;
    font-size: 14px;
    font-weight: bold;
  }

  textarea.ant-input {
    width: 950px;
    margin-left: 20px;
  }

  .delete,
  .add-list {
    float: right;
    font-size: 14px;
    font-weight: 400;
    width: 48px;
    margin-left: 25px;
    height: 100%;
    color: #606266;
    cursor: pointer;
  }

  .add-list {
    color: #35b5fe;
  }

  .ant-btn-primary,
  .ant-btn-lg {
    float: right;
    width: 95px;
    border-radius: 4px;
    margin-left: 20px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .interview {
    display: flex;
    align-items: flex-start;
    width: 100%;

    .interview-list {
      font-weight: bold;
      width: 950px;
    }
  }

  .interview-body {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 10px;
  }

  .company-list {
    padding: 10px;
    border: #ededed 1px solid;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .company-name {
    padding: 2px 5px;
    background: deepskyblue;
    margin-top: 10px;
    color: white;
    float: left;
    border-radius: 4px;
    position: relative;

    .delete-com {
      position: absolute;
      right: -8px;
      top: -8px;
      border-radius: 50%;
      line-height: 16px;
      text-align: center;
      background: red;
      color: white;
      width: 16px;
      height: 16px;
      font-size: 10px;
      cursor: pointer;
    }
  }

  .addProduct {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .tags-list {
    width: 100%;

    .tags-info {
      max-width: 600px;
    }

    div {
      float: left;
      margin-bottom: 10px;
    }

    .item-title {
      color: black;
      font-weight: bold;
    }
  }

  .bottom-button {
    width: 100%;
    height: 50px;
    margin-top: 20px;
  }

  .btn-affix {
    position: fixed;
    bottom: 90px;
    right: 90px;
  }

  .affix {
    background: rgba(0, 0, 0, 0.5);
    height: 120px;
    right: 0;
    left: 0;
    position: fixed;
    bottom: 0;
  }

  .v-enter,
  .v-leave-to {
    opacity: 0;
  }

  .v-enter-active,
  .v-leave-active {
    transition: all 1s ease;
  }

  .more-portrait {
    text-align: center;
    margin: 10px 0;
  }
  .ai-button {
    width: 147px;
    height:32px;
    background-color: #7788FF;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 10px;
    justify-content: center;
    align-items: center;
    display: flex;
    color: #FFFFFF;
    font-size:12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  // 取消默认外边框虚线
  .vdr.active:before {
    display: none;
  }
}
</style>
